// Dependencies
import React from 'react';
import radium from "radium";
import CheckoutButtons from "../../CheckoutButtons";
import javascriptService from "../../../../lib/javascript-service";
import './VR_PAY.scss'
import {ThemeContext} from "../../../../components/theme/Theme.jsx";
import vrpConfig from "./vr_pay_config.js";
import ZigZagBox from "../../../../components/zig-zag-box/ZigZagBox";
import '../../CheckoutProcess.scss';

interface VR_PAY_props {
	checkoutProps: any,
	next: any,
	pop: any,
	reset: any,
	btnLabels: any
}

function VR_PAY(props: VR_PAY_props) {
	const context = React.useContext(ThemeContext);
	const dataBrands = props.checkoutProps.output.dataBrands;
	const vrpScript = props.checkoutProps.output.scriptUrl;
	const shopperResultUrl = props.checkoutProps.output.shopperResultUrl;


	const [scriptLoaded, setScriptLoaded] = React.useState(false);
	const [renderForm, setRenderForm] = React.useState(true);
	const [dataSubmitted, setDataSubmitted] = React.useState(false);

	// Styles
	const iFrameBtnStyle =  `
		background-color: ${context.themeManager.value('hightlight-button', 'backgroundColor','bg-color-button-hightlight')};
		color: ${context.themeManager.value('hightlight-button', 'color', 'fg-color-button-hightlight')};
		border: ${context.themeManager.valueOrDefault('hightlight-button', 'border', null, 'none')};`
	const iFrameBtnStyleHover =  `
		background-color: ${context.themeManager.value('hightlight-button', 'backgroundColorHover','bg-color-button-hightlight')};
		color: ${context.themeManager.value('hightlight-button', 'colorHover', 'fg-color-button-hightlight')};
		border: ${context.themeManager.valueOrDefault('hightlight-button', 'borderHover', null, 'none')};`
	const iFrameInputStyle = `
		background-color: ${context.themeManager.value('form-select', 'borderColor', 'bg-color-form-element')};
		border:${context.themeManager.value('form-select', 'borderColor', 'border-color-form-element')};
		color:${context.themeManager.value('form-select', 'color', 'fg-color-form-element')};`
	const iFrameIFrameInputStyle = `
		border-color:${context.themeManager.value('form-select', 'borderColor', 'border-color-form-element')} !important;`;
	const iFrameInputHasErrorStyle = `
		border-color: ${context.themeManager.valueOrDefault('vr-pay', 'borderColorError', null, '#e10101')} !important`
	const iFrameHasErrorHintStyle = `
		color: ${context.themeManager.valueOrDefault('vr-pay', 'hintColor', null, '#e10101')}`
	const iFrameIconStyle = `
		color: ${context.themeManager.value('vr-pay', 'iconColor', 'fg-color-text-highlight')}`
	const iFrameWpwlWrapperBrandStyle = `
		background-color: ${context.themeManager.value('vr-pay', 'iconColor', 'bg-color-form-element')}`
	const iFrameAutocompleteItem = `color:${context.themeManager.value('form-select', 'color', 'fg-color-form-element')};`
	const iFrameAutocompleteItemActive = `background-color: ${context.themeManager.value('form-select', 'colorHover', 'bg-color-button-default')};`


	const iFrameStyle = `
		.wpwl-button-pay, .wpwl-button-pay[disabled], .wpwl-button-pay[disabled]:hover { ${iFrameBtnStyle}}
		.wpwl-button-pay:hover { ${iFrameBtnStyleHover}}
		.wpwl-control {${iFrameInputStyle}}
		.wpwl-control-iframe, .wpwl-control:focus {${iFrameIFrameInputStyle}}
		.wpwl-has-error {${iFrameInputHasErrorStyle}}
		.wpwl-has-error~.wpwl-hint {${iFrameHasErrorHintStyle}}
		.wpwl-wrapper .ui-icon-help {${iFrameIconStyle}}
		.wpwl-wrapper.wpwl-wrapper-brand {${iFrameWpwlWrapperBrandStyle}}
		.ui-widget-content a {${iFrameAutocompleteItem}}
		.ui-widget-content .ui-state-active {${iFrameAutocompleteItemActive}`

	const reParam = new URL(window.location.href).searchParams.get("v");

	function reloadPageOnBfCacheRestore (event:any) {
		if (event.persisted) {
			window.location.reload()
		}
	}

	React.useEffect(() => {
		//check if page was restored from the bfcache
		window.addEventListener('pageshow', reloadPageOnBfCacheRestore);

		//config
		window.wpwlOptions = vrpConfig

		//custom css with theme values
		const inlineCss = document.createElement('style');
		inlineCss.innerHTML = iFrameStyle;
		document.body.append(inlineCss);

		//vr-pay
		javascriptService.appendScript(
			vrpScript,
			false,
			() => setScriptLoaded(true),
			() => handleScriptLoadError()
		);

		if (reParam === 'vr_success') {
			window.history.replaceState(null, '', window.location.pathname);
			setRenderForm(false);
			setDataSubmitted(true);
			props.next({method: props.checkoutProps.method, provider: props.checkoutProps.provider});
		}

		return () => {
			// remove scripts and unload wpwl
			const wpwl = window.wpwl ? window.wpwl : null
			if(wpwl && wpwl.unload) {
				wpwl.unload()
			}
			javascriptService.removeScript(vrpScript, () => delete window.wpwlOptions)
			inlineCss.remove();
			window.removeEventListener('pageshow', reloadPageOnBfCacheRestore);
		};
		// run useEffect only once --> deps have to be empty
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	function handleScriptLoadError() {
		return Promise.reject('Error loading VR Payment script');
	}
	return (
		<div>
			<h1 className="page__headline"
				dangerouslySetInnerHTML={{
					__html: context.themeManager
						.getThemeTextOrHardcodedDefault('vrpCreditHeadline'),
				}}
			/>
			<ZigZagBox>
				{(scriptLoaded && renderForm) &&
					<form action={shopperResultUrl + '?v=vr_success'} className="paymentWidgets" data-brands={dataBrands}></form>
				}
				{dataSubmitted &&
					<div className="text--data-processed" dangerouslySetInnerHTML={{
						__html: context.themeManager
							.getThemeTextOrHardcodedDefault('vrpDataProcessedText'),
					}}></div>
				}
			</ZigZagBox>
			<CheckoutButtons
				btnResetLabel={props.btnLabels.resetBtnLabel}
				btnNextLabel={props.btnLabels.nextBtnLabel}
				btnBackLabel={props.btnLabels.backBtnLabel}
				onBackClick={()=>props.pop({method: props.checkoutProps.method, provider: props.checkoutProps.provider})}
				onResetClick={()=>props.reset({method: props.checkoutProps.method, provider: props.checkoutProps.provider})}
				hideNextButton={true}
			/>
		</div>
	);
}

const RadiumVRPay = radium(VR_PAY);

/* if component is using radium set name (name is used in CheckoutDispatcherPage) */
// @ts-expect-error Cannot assign to name because it is a read-only property.
RadiumVRPay["name"] = VR_PAY.name

export default RadiumVRPay;
